export default __webpack_public_path__ + "static/media/play.305b8276.svg";